<!-- Mobile topbar -->
<div
  class="cb-top-navbar-mobile-topbar"
  [ngStyle]="{
    '--background': background(),
  }"
>
  @if (logo()) {
    <img [src]="logo()" alt="Logo" [routerLink]="homeRoute" />
  }
  <div
    class="cb-top-navbar-hamburger"
    (click)="toggleOpen()"
    [class.cb-open]="isOpen()"
  >
    <span></span>
    <span></span>
  </div>
</div>

<div
  class="cb-top-navbar-wrapper"
  [class.cb-route-color]="!!currentRouteColor()"
  [class.cb-open]="isOpen()"
  [ngStyle]="{
    '--route-color': currentRouteColor(),
    '--background': background(),
  }"
>
  <div class="cb-top-navbar-container">
    <div class="cb-top-navbar-header">
      @if (logo()) {
        <img [src]="logo()" alt="Logo" [routerLink]="homeRoute" />
      }
    </div>
    <div class="cb-top-navbar-routes">
      @for (item of navItems(); track $index) {
        <ng-container
          *ngTemplateOutlet="NavbarItem; context: { $implicit: item }"
        ></ng-container>
      }
    </div>
    <div class="cb-top-navbar-controls">
      <div class="cb-top-navbar-routes">
        @for (item of footerItems(); track $index) {
          <ng-container
            *ngTemplateOutlet="NavbarItem; context: { $implicit: item }"
          ></ng-container>
        }
      </div>
      <div
        class="cb-top-navbar-avatar"
        [cbPopover]="profilePopover"
        [popoverDistance]="6"
        [showArrow]="false"
        popoverPosition="bottom"
        [closeOnInsideClick]="true"
      >
        <cb-user-avatar
          size="sm"
          [userId]="userId()!"
          [label]="profileName() || null"
          [onlyAvatar]="true"
        ></cb-user-avatar>
      </div>
    </div>
  </div>
</div>

<ng-template #NavbarItem let-item>
  @if (
    (!item.show || item.show() !== false) &&
    (!item.showSignal || item.showSignal())
  ) {
    @let icon = item.icon;
    @let label = item.label;
    <div
      class="cb-top-navbar-item-container"
      routerLinkActive="cb-current"
      [class.cb-current]="checkIsActive(item)"
      [routerLink]="item.type === 'route' ? item.routerLink : null"
      (isActiveChange)="routeActivationChanged(item, $event)"
      [cbPopover]="item.type === 'group' ? GroupItems : undefined"
      (click)="handleItemClick(item)"
    >
      <div class="cb-top-navbar-item" [class.cb-icon]="icon && !label">
        @if (icon) {
          <cb-icon [name]="icon"></cb-icon>
        }

        @if (label) {
          <p>{{ label | translate }}</p>
        }
      </div>
    </div>
  }

  <ng-template #GroupItems>
    <div class="cb-top-navbar-group-container">
      @for (item of item.items; track $index) {
        <ng-container
          *ngTemplateOutlet="GroupNavbarItem; context: { $implicit: item }"
        ></ng-container>
      }
    </div>
  </ng-template>

  <ng-template #GroupNavbarItem let-item>
    @if (
      (!item.show || item.show() !== false) &&
      (!item.showSignal || item.showSignal())
    ) {
      @let icon = item.icon;
      @let label = item.label;
      <div
        class="cb-top-navbar-item-container"
        routerLinkActive="cb-current"
        [class.cb-current]="checkIsActive(item)"
        [routerLink]="item.type === 'route' ? item.routerLink : null"
        (isActiveChange)="routeActivationChanged(item, $event)"
        (click)="handleItemClick(item)"
      >
        <div class="cb-top-navbar-item" [class.cb-icon]="icon && !label">
          @if (icon) {
            <cb-icon [name]="icon"></cb-icon>
          }

          @if (label) {
            <p>{{ label | translate }}</p>
          }
        </div>
      </div>
    }
  </ng-template>
</ng-template>

<ng-template #profilePopover>
  <div class="cb-profile-popover">
    @if (!restrictedUserOptions()) {
      <div class="cb-profile-popover-group">
        @if (tenantName()) {
          <div class="cb-profile-popover-tenant">
            <cb-icon name="cb-base-bold-business"></cb-icon>
            <p>{{ tenantName() }}</p>
          </div>
        }
        <div class="cb-profile-popover-options">
          <div class="cb-profile-popover-option" (click)="changeTenant()">
            <cb-icon name="cb-base-outline-refresh"></cb-icon>
            <p>{{ "SECTIONS.ROUTES.CHANGE_TENANT" | translate }}</p>
          </div>
          <!-- <div class="cb-profile-popover-option" [routerLink]="createTenantUrl">
            <cb-icon name="cb-base-outline-add"></cb-icon>
            <p>{{ "SECTIONS.ROUTES.CREATE_TENANT" | translate }}</p>
          </div> -->
        </div>
      </div>
    }
    <div class="cb-profile-popover-group">
      @if (userId()) {
        <div class="cb-profile-popover-avatar">
          <cb-user-avatar
            [userId]="userId()!"
            size="sm"
            [subtitle]="profileEmail() || null"
          ></cb-user-avatar>
        </div>
      }
      <div class="cb-profile-popover-options">
        <div class="cb-profile-popover-option" (click)="contactSupport()">
          <cb-icon name="cb-base-outline-help"></cb-icon>
          <p>{{ "SECTIONS.ROUTES.CONTACT_SUPPORT" | translate }}</p>
        </div>
        <div class="cb-profile-popover-option" (click)="reportBug()">
          <cb-icon name="cb-base-outline-bug"></cb-icon>
          <p>{{ "SECTIONS.ROUTES.REPORT_BUG" | translate }}</p>
        </div>
        @if (!restrictedUserOptions()) {
          <div class="cb-profile-popover-option" [routerLink]="userSettingsUrl">
            <cb-icon name="cb-base-outline-settings"></cb-icon>
            <p>{{ "SECTIONS.ROUTES.USER_SETTINGS" | translate }}</p>
          </div>
        }
        <div class="cb-profile-popover-option cb-error" (click)="logout.emit()">
          <cb-icon name="cb-base-outline-logout"></cb-icon>
          <p>{{ "SECTIONS.ROUTES.LOGOUT" | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
